<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Grupy opcji</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Grupy opcji</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Grupy opcji</h5>
          </div>
          <div class="ibox-content">
            <router-link v-if="canAddGroup" to="/product-option-group/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-6 m-b-xs">
                <div class="form-group">
                  <label class="control-label">Wpisz liczbę wierszy:</label>
                  <input
                    class="form-control inputClass rows-input"
                    type="text"
                    :value="rowsPerPage || ''"
                    @input="updateRowsPerPageInput($event.target.value)"
                    @change="setRowsPerPage"
                    @click="isSearch = false"
                  />
                </div>
              </div>
              <div class="col-sm-6 m-b-xs" v-if="sitesOptions.length">
                <div class="form-group domain-select">
                  <label class="control-label">Domena</label>
                  <select
                    :value="filterSitePk || ''"
                    class="form-control inputClass"
                    @change="updateFilterSitePk($event.target.value)"
                  >
                    <option value="">Wybierz domenę</option>
                    <option
                      v-for="option in sitesOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select
                      :value="serverOptions.rowsPerPage"
                      @change="
                        updateServerOption('rowsPerPage', $event.target.value)
                      "
                    >
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      :value="serverOptions.page"
                      @input="updateServerOption('page', $event.target.value)"
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <div class="table-responsive table-search native-table-search">
                  <table
                    ref="tableRef"
                    :key="tableRenderKey"
                    class="table table-striped table-bordered"
                  >
                    <thead>
                      <tr>
                        <th class="drag-column"></th>
                        <th class="index-column">#</th>
                        <th
                          v-for="header in tableHeaders"
                          :key="header.value"
                          :class="[
                            'native-header-cell',
                            { sortable: header.sortable },
                          ]"
                        >
                          <div class="native-header-content">
                            <button
                              type="button"
                              class="native-sort-button"
                              @click="toggleSort(header.value)"
                            >
                              <span>{{ header.text }}</span>
                              <i
                                v-show="isSortedHeader(header.value)"
                                :class="sortIconClass(header.value)"
                                class="sort-icon fa"
                              ></i>
                            </button>
                            <input
                              v-if="header.search"
                              :value="searchValue[header.value] || ''"
                              class="table-search native-header-input"
                              type="text"
                              @input="
                                updateSearchValue(
                                  header.value,
                                  $event.target.value
                                )
                              "
                              @keyup="search"
                              @click.stop="isSearch = true"
                            />
                          </div>
                        </th>
                        <th class="actions-column">Akcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="loading">
                        <td
                          :colspan="tableHeaders.length + 3"
                          class="text-center"
                        >
                          Ładowanie...
                        </td>
                      </tr>
                      <tr v-else-if="!items.length">
                        <td
                          :colspan="tableHeaders.length + 3"
                          class="text-center"
                        >
                          Brak wyników
                        </td>
                      </tr>
                      <template v-else>
                        <tr
                          v-for="(item, index) in items"
                          :key="item.pk"
                          :class="['native-data-row', bodyRowClassName(item)]"
                          :draggable="canReorder"
                          @dragstart="onGroupDragStart(index, $event)"
                          @dragover="onGroupDragOver(index, $event)"
                          @drop="onGroupDrop(index, $event)"
                          @dragend="onGroupDragEnd"
                        >
                          <td class="drag-column" @click.stop>
                            <span
                              v-if="canReorder"
                              class="drag-handle"
                              title="Przeciągnij, aby zmienić kolejność"
                            >
                              <i class="fa fa-bars"></i>
                            </span>
                          </td>
                          <td class="index-column">{{ rowNumber(index) }}</td>
                          <td>{{ item.pk }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.description }}</td>
                          <td>{{ item.group_choice }}</td>
                          <td>{{ item.date_added }}</td>
                          <td>{{ item.date_modified }}</td>
                          <td>{{ item.last_modified_by }}</td>
                          <td>{{ item.created_by }}</td>
                          <td class="actions-column" @click.stop>
                            <button
                              v-if="canChangeGroup"
                              @click.stop="editPOG(item)"
                              class="btn btn-warning btn-xs"
                            >
                              <i class="fa fa-pencil"></i>
                            </button>
                            <router-link
                              v-if="canViewOptions"
                              :to="{
                                name: 'ProductOptionsInGroup',
                                params: { group_pk: item.pk },
                              }"
                            >
                              <button
                                class="btn btn-info btn-xs ml-5"
                                @click.stop
                              >
                                <i class="fa fa-eye"></i>
                              </button>
                            </router-link>
                            <button
                              v-if="canDeleteGroup"
                              @click.stop="
                                showModal = item.pk;
                                deleteName = item.name;
                              "
                              class="btn btn-danger btn-xs"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select
                      :value="serverOptions.rowsPerPage"
                      @change="
                        updateServerOption('rowsPerPage', $event.target.value)
                      "
                    >
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      :value="serverOptions.page"
                      @input="updateServerOption('page', $event.target.value)"
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deletePOG(showModal)"
    @callbackClose="showModal = false"
  />
  <div v-if="showEditModal" class="modal-dialog pog-edit-modal">
    <div ref="editModalRef" class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Edycja Grupy</h4>
        </div>
        <div class="modal-body">
          <div v-if="editLoading" class="text-center p-md">Ładowanie...</div>
          <div v-else class="form-horizontal">
            <div class="form-group">
              <label class="control-label col-sm-2">Nazwa pl</label>
              <div class="col-sm-10">
                <input
                  v-model="editNamePl"
                  name="name_pl"
                  type="text"
                  class="form-control inputClass"
                  placeholder="Nazwa pl"
                  required="required"
                />
                <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.name_pl[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Nazwa en</label>
              <div class="col-sm-10">
                <input
                  v-model="editNameEn"
                  name="name_en"
                  type="text"
                  class="form-control inputClass"
                  placeholder="Nazwa en"
                  required="required"
                />
                <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.name_en[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Nazwa de</label>
              <div class="col-sm-10">
                <input
                  v-model="editNameDe"
                  name="name_de"
                  type="text"
                  class="form-control inputClass"
                  placeholder="Nazwa de"
                  required="required"
                />
                <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.name_de[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Nazwa de_de</label>
              <div class="col-sm-10">
                <input
                  v-model="editNameCpde"
                  name="name_cpde"
                  type="text"
                  class="form-control inputClass"
                  placeholder="Nazwa de_de"
                  required="required"
                />
                <div v-if="errorsAdminData?.data?.name_cpde" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.name_cpde[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Nazwa de_en</label>
              <div class="col-sm-10">
                <input
                  v-model="editNameCpen"
                  name="name_cpen"
                  type="text"
                  class="form-control inputClass"
                  placeholder="Nazwa de_en"
                  required="required"
                />
                <div v-if="errorsAdminData?.data?.name_cpen" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.name_cpen[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Opis</label>
              <div class="col-sm-10 QuillEditor-box">
                <QuillEditor
                  theme="snow"
                  contentType="html"
                  v-model:content="editForm.description"
                />
                <div
                  v-if="errorsAdminData?.data?.description"
                  class="has-error"
                >
                  <span class="help-block">
                    {{ errorsAdminData.data.description[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label col-sm-2">Wybór</label>
              <div class="col-sm-10">
                <Multiselect
                  v-model="editForm.group_choice"
                  mode="single"
                  placeholder="Wybór"
                  track-by="name"
                  label="name"
                  :close-on-select="true"
                  :search="true"
                  :options="POGChoices"
                >
                </Multiselect>
                <div
                  v-if="errorsAdminData?.data?.group_choice"
                  class="has-error"
                >
                  <span class="help-block">
                    {{ errorsAdminData.data.group_choice[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <div class="checkbox checkbox-primary">
                  <label>
                    <input
                      v-model="editForm.determines_paper_type"
                      name="determines_paper_type"
                      type="checkbox"
                    />
                    <span>Określa rodzaj papieru</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <div class="checkbox checkbox-primary">
                  <label>
                    <input
                      v-model="editForm.select_from_list"
                      name="select_from_list"
                      type="checkbox"
                    />
                    <span>Wybór z listy</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <div class="checkbox checkbox-primary">
                  <label>
                    <input
                      v-model="editForm.hide_in_order"
                      name="hide_in_order"
                      type="checkbox"
                    />
                    <span>Ukryj na karcie zamówienia i karcie montażu</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="cancel" class="btn btn-white">Anuluj</button>
          <button
            v-if="canChangeGroup"
            @click="saveEdit"
            :disabled="editLoading"
            class="btn btn-primary"
          >
            Zapisz
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showEditModal" @click="cancel" class="modal-backdrop"></div>
</template>

<script>
import { computed, watch, ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  productOptionGroupPermissionsConst,
  productOptionPermissionsConst,
} from "../../constants/productConstants";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";

export default {
  name: "ProductOptionList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.add)
    );
    const canChangeGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.update)
    );
    const canDeleteGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.delete)
    );
    // The options of a group are a separate model - the old panel guards the
    // group detail route with the option view permission.
    const canViewOptions = computed(() =>
      hasPermission(productOptionPermissionsConst.view)
    );
    const deletepOptionsGroupData = computed(
      () => store.getters.getDeletepOptionsGroupData
    );
    const pogData = computed(() => store.getters.getPOGData);
    const updatepOptionsGroupData = computed(
      () => store.getters.getUpdatepOptionsGroupData
    );
    const pOptionsGroupData = computed(
      () => store.getters.getpOptionsGroupData
    );
    const POGChoicesData = computed(() => store.getters.getPOGChoicesData);
    const sitesData = computed(() => store.getters.getSitesData);
    const showEditModal = ref(false);
    const editLoading = ref(false);
    const currentEditPk = ref(null);
    const pOptionsGroupObj = ref({
      select_from_list: false,
      determines_paper_type: false,
      hide_in_order: false,
    });
    const editForm = ref({
      select_from_list: false,
      determines_paper_type: false,
      hide_in_order: false,
    });
    const editModalRef = ref(null);
    const editNamePl = ref("");
    const editNameEn = ref("");
    const editNameDe = ref("");
    const editNameCpde = ref("");
    const editNameCpen = ref("");
    const tableRef = ref(null);
    const filterSitePk = ref(null);
    const sitesOptions = ref([]);
    let headers = [
      { text: "", value: "drag" },
      { text: "ID", value: "pk", sortable: true, search: true },
      { text: "Nazwa", value: "name", sortable: true, search: true },
      { text: "Opis", value: "description", sortable: true, search: true },
      { text: "Wybór", value: "group_choice", sortable: true, search: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const POGChoices = ref([]);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const draggedGroupPk = ref(null);
    const dragOverGroupPk = ref(null);
    const siteFilterInitialized = ref(false);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
      sortBy: "position",
      sortType: "asc",
    });
    const tableHeaders = computed(() =>
      headers.filter((header) => !["drag", "actions"].includes(header.value))
    );
    const tableRenderKey = computed(
      () =>
        `${serverOptions.value.sortBy}-${serverOptions.value.sortType}-${items.value.length}`
    );

    // Reordering persists a new position on the group, so it is an edit.
    const canReorder = computed(() => canChangeGroup.value);

    const bodyRowClassName = (item) => {
      const classes = ["pog-draggable-row"];

      if (canReorder.value) {
        classes.push("pog-reorder-enabled");
      }
      if (dragOverGroupPk.value === item.pk) {
        classes.push("drag-over-row");
      }

      return classes.join(" ");
    };
    const rowNumber = (index) => {
      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue =
        Number(serverOptions.value.rowsPerPage) || defRowsPerPage.value;

      return (page - 1) * rowsPerPageValue + index + 1;
    };
    const updateRowsPerPageInput = (value) => {
      rowsPerPage.value = value;
    };
    const updateServerOption = (key, value) => {
      serverOptions.value = {
        ...serverOptions.value,
        [key]: value,
      };
    };
    const updateFilterSitePk = (value) => {
      filterSitePk.value = value || null;
    };
    const updateSearchValue = (key, value) => {
      searchValue.value = {
        ...searchValue.value,
        [key]: value,
      };
    };
    const toggleSort = (value) => {
      if (serverOptions.value.sortBy === value) {
        serverOptions.value.sortType =
          serverOptions.value.sortType === "asc" ? "desc" : "asc";
        return;
      }

      serverOptions.value.sortBy = value;
      serverOptions.value.sortType = "asc";
    };
    const isSortedHeader = (value) => serverOptions.value.sortBy === value;
    const sortIconClass = (value) =>
      isSortedHeader(value) && serverOptions.value.sortType === "desc"
        ? "fa-arrow-down"
        : "fa-arrow-up";
    const getpOptionsGroup = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getpOptionsGroup", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        site_pk: filterSitePk.value,
      });
    };

    const deletePOG = (pk) => {
      showModal.value = false;
      if (!canDeleteGroup.value) {
        return;
      }
      store.dispatch("deletepOptionsGroup", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeGroup.value) {
        return;
      }
      const pk = currentEditPk.value || pOptionsGroupObj.value?.pk;
      const form = editForm.value || {};
      const rawGroupChoice = form.group_choice;
      const normalizedGroupChoice =
        typeof rawGroupChoice === "object" && rawGroupChoice !== null
          ? rawGroupChoice.value
          : rawGroupChoice;
      const stripHtml = (value) => {
        if (!value || typeof value !== "string") {
          return "";
        }
        if (typeof document === "undefined") {
          return value;
        }
        const temp = document.createElement("div");
        temp.innerHTML = value;
        return (temp.textContent || temp.innerText || "").trim();
      };
      const payload = {
        pk,
        name_pl: editNamePl.value,
        name_en: editNameEn.value,
        name_de: editNameDe.value,
        name_cpde: editNameCpde.value,
        name_cpen: editNameCpen.value,
        description: stripHtml(form.description),
        group_choice: normalizedGroupChoice,
        determines_paper_type: Boolean(form.determines_paper_type),
        select_from_list: Boolean(form.select_from_list),
        hide_in_order: Boolean(form.hide_in_order),
        product_options: Array.isArray(form.product_options)
          ? form.product_options
          : [],
        position: form.position ?? 1,
      };
      store.dispatch("updatepOptionsGroup", {
        pk,
        data: payload,
      });
    };

    const cancel = () => {
      showEditModal.value = false;
      editLoading.value = false;
      currentEditPk.value = null;
    };

    const editPOG = (item) => {
      if (!canChangeGroup.value || !item?.pk) {
        return;
      }

      currentEditPk.value = item.pk;
      editLoading.value = true;
      showEditModal.value = true;
      store.dispatch("getPOG", { pk: item.pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        setTimeout(() => {
          selectPage(1);
          getpOptionsGroup();
          isSearch.value = false;
        }, 1000);
      }
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterSitePk.value = null;
      serverOptions.value.sortBy = "position";
      serverOptions.value.sortType = "asc";
      selectPage(1);
      getpOptionsGroup();
    };
    store.dispatch("getPOGChoices");

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };
    const setBodyScrollLock = (isLocked) => {
      if (typeof document === "undefined") {
        return;
      }
      document.body.style.overflow = isLocked ? "hidden" : "";
    };

    const onGroupDragStart = (index, event) => {
      if (!canReorder.value) {
        event.preventDefault();
        return;
      }

      const item = items.value[index];
      if (!item) {
        event.preventDefault();
        return;
      }

      draggedGroupPk.value = item.pk;
      if (event?.dataTransfer) {
        event.dataTransfer.effectAllowed = "move";
      }
    };

    const onGroupDragOver = (index, event) => {
      if (!canReorder.value) {
        return;
      }

      const item = items.value[index];
      if (!item) {
        return;
      }

      event.preventDefault();
      dragOverGroupPk.value = item.pk;
    };

    const onGroupDragEnd = () => {
      draggedGroupPk.value = null;
      dragOverGroupPk.value = null;
    };

    const onGroupDrop = async (index, event) => {
      if (!canReorder.value) {
        return;
      }

      event.preventDefault();
      const targetItem = items.value[index];

      if (
        !draggedGroupPk.value ||
        !targetItem ||
        draggedGroupPk.value === targetItem.pk
      ) {
        onGroupDragEnd();
        return;
      }

      const fromIndex = items.value.findIndex(
        (item) => item.pk === draggedGroupPk.value
      );
      const toIndex = items.value.findIndex(
        (item) => item.pk === targetItem.pk
      );

      if (fromIndex < 0 || toIndex < 0) {
        onGroupDragEnd();
        return;
      }

      const [movedGroup] = items.value.splice(fromIndex, 1);
      items.value.splice(toIndex, 0, movedGroup);

      const page = Number(serverOptions.value.page) || 1;
      const rowsPerPageValue = Number(serverOptions.value.rowsPerPage) || 25;
      const newPosition = (page - 1) * rowsPerPageValue + toIndex + 1;

      onGroupDragEnd();

      try {
        await store.dispatch("reorderpOptionsGroup", {
          pk: movedGroup.pk,
          position: newPosition,
        });
        store.dispatch("showToaster", {
          type: "success",
          content: "Kolejność grup opcji została zaktualizowana",
        });
        await getpOptionsGroup();
      } catch (e) {
        await getpOptionsGroup();
        store.dispatch("showToaster", {
          type: "error",
          content: "Nie udało się zmienić kolejności grup opcji",
        });
      }
    };

    onMounted(() => {
      if (localStorage.getItem("productOGSearchValue") !== null) {
        searchValue.value = localStorage.getItem("productOGSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      store.dispatch("getSites");
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "productOGSearchValue",
          JSON.stringify(searchValue.value)
        );
        getpOptionsGroup();
      },
      { deep: true }
    );

    watch(
      () => pOptionsGroupData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        const raw = Array.isArray(newValue?.data?.results)
          ? newValue.data.results
          : Array.isArray(newValue?.data?.data)
          ? newValue.data.data
          : Array.isArray(newValue?.data)
          ? newValue.data
          : [];
        sitesOptions.value = raw.map((s) => ({ name: s.name, value: s.pk }));

        if (!hasSiteOptionValue(sitesOptions.value, filterSitePk.value)) {
          const defaultSiteValue = getSiteValueFromCurrentUrl(
            sitesOptions.value
          );
          if (defaultSiteValue !== null) {
            filterSitePk.value = defaultSiteValue;
          }
        }

        if (!siteFilterInitialized.value) {
          siteFilterInitialized.value = true;
          getpOptionsGroup();
        }
      }
    );

    watch(
      () => filterSitePk.value,
      function () {
        selectPage(1);
        getpOptionsGroup();
      }
    );
    watch(
      () => showEditModal.value,
      function (isOpen) {
        setBodyScrollLock(isOpen);
      }
    );

    watch(
      () => pogData.value,
      function (newValue) {
        if (!showEditModal.value || !editLoading.value) {
          return;
        }
        const cloned = JSON.parse(JSON.stringify(newValue?.data || {}));
        pOptionsGroupObj.value = cloned;
        editForm.value = cloned;
        editNamePl.value = cloned.name_pl;
        editNameEn.value = cloned.name_en;
        editNameDe.value = cloned.name_de;
        editNameCpde.value = cloned.name_cpde;
        editNameCpen.value = cloned.name_cpen;
        editLoading.value = false;
      }
    );

    watch(
      () => deletepOptionsGroupData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Grupa opcji została usunięta",
          });
        }
        getpOptionsGroup();
      }
    );

    watch(
      () => updatepOptionsGroupData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getpOptionsGroup();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
          cancel();
          return;
        }
        store.dispatch("showToaster", {
          type: "error",
          content:
            newValue?.data?.detail ||
            "Nie udało się zapisać zmian. Sprawdź pola formularza.",
        });
      }
    );

    watch(
      () => POGChoicesData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          POGChoices.value.push({
            name: element[1],
            value: element[0],
          });
        });
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getpOptionsGroup();
          isSearch.value = false;
        }
      },
      { deep: true }
    );
    onBeforeUnmount(() => {
      setBodyScrollLock(false);
    });

    return {
      canAddGroup,
      canChangeGroup,
      canDeleteGroup,
      canViewOptions,
      headers,
      items,
      itemsAll,
      loading,
      tableRef,
      tableHeaders,
      tableRenderKey,
      serverOptions,
      canReorder,
      bodyRowClassName,
      rowNumber,
      updateRowsPerPageInput,
      updateServerOption,
      updateFilterSitePk,
      updateSearchValue,
      toggleSort,
      isSortedHeader,
      sortIconClass,
      showModal,
      showEditModal,
      editLoading,
      deletePOG,
      deleteName,
      pOptionsGroupObj,
      editForm,
      editModalRef,
      editNamePl,
      editNameEn,
      editNameDe,
      editNameCpde,
      editNameCpen,
      cancel,
      editPOG,
      saveEdit,
      searchValue,
      search,
      resetFilters,
      isSearch,
      rowsPerPage,
      filterSitePk,
      sitesOptions,
      POGChoices,
      setRowsPerPage,
      selectPage,
      onGroupDragStart,
      onGroupDragOver,
      onGroupDrop,
      onGroupDragEnd,
    };
  },
  computed: {},
};
</script>

<style scoped>
.rows-input {
  width: 160px;
}

.domain-select {
  width: 320px;
  margin-left: auto;
}

.domain-select :deep(.multiselect) {
  z-index: 9999999;
}

.domain-select :deep(.multiselect-dropdown) {
  z-index: 9999999;
}

.drag-handle {
  display: inline-block;
  cursor: move;
  color: #676a6c;
}

.native-table-search {
  margin-top: 15px;
}

.native-table-search table {
  margin-bottom: 0;
}

.native-header-cell {
  padding: 0 !important;
  min-width: 130px;
  vertical-align: top !important;
}

.native-header-content {
  position: relative;
  display: flex;
  flex-flow: column;
  padding: 10px 10px 40px;
  min-height: 58px;
}

.native-header-content > span {
  color: #373737;
}

.native-sort-button {
  position: relative;
  display: block;
  width: 100%;
  padding: 0 20px 0 0;
  border: 0;
  background: transparent;
  color: #373737;
  text-align: left;
  cursor: pointer;
}

.native-header-input {
  background: #f1f1f1;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 30px;
  padding: 0 5px;
  border: 0;
  border-top: 1px solid #e0e0e0;
}

.sort-icon {
  position: absolute;
  top: 0;
  right: 0;
}

.drag-column {
  width: 50px;
}

.index-column {
  width: 50px;
}

.actions-column {
  width: 130px;
  white-space: nowrap;
}

.native-data-row {
  cursor: default;
}

.pog-edit-modal {
  width: calc(100% - 30px);
  max-width: 1000px;
  max-height: calc(100vh - 30px);
}

.pog-edit-modal .modal-content {
  max-height: calc(100vh - 30px);
  display: flex;
}

.pog-edit-modal .inmodal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 30px);
}

.pog-edit-modal .modal-body {
  overflow-y: auto;
}

.native-data-row.pog-reorder-enabled {
  cursor: move;
}

.native-data-row.drag-over-row {
  background-color: #f3f3f4;
}
</style>
